var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportantModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8722 30H0.836802C0.54574 30 0.254679 29.8575 0.109148 29.5718C-0.0363827 29.2861 -0.0363827 28.9997 0.109148 28.714L16.6995 0.434468C16.9906 0.00598591 17.5726 -0.13712 18.0091 0.148534C18.1547 0.291362 18.3005 0.291641 18.3005 0.434468L34.8909 28.714C35.0364 28.9997 35.0364 29.2861 34.8909 29.5718C34.4543 29.8575 34.1633 30 33.8722 30ZM2.43743 28.1435H32.4169L17.4272 2.57688L2.43743 28.1435Z",
    fill: "#E0AD03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2841 21.286C16.702 21.286 16.4111 20.858 16.4111 20.4296V11.288C16.4111 10.7167 16.8477 10.4316 17.4298 10.4316C17.8664 10.4316 18.3031 10.8596 18.3031 11.288V20.4296C18.3031 20.858 17.8662 21.286 17.2841 21.286Z",
    fill: "#E0AD03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2841 26.2838C16.702 26.2838 16.4111 25.8559 16.4111 25.4274V23.5709C16.4111 22.9996 16.8477 22.7131 17.4298 22.7131C17.8664 22.7131 18.3031 23.1425 18.3031 23.5709V25.4274C18.3031 25.8559 17.8662 26.2838 17.2841 26.2838Z",
    fill: "#E0AD03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantModal);
export default __webpack_public_path__ + "static/media/important_modal.4dfda90682a3525a351d8aa2aeb8bfe6.svg";
export { ForwardRef as ReactComponent };